import React, { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import SliderWrapper from 'jd-library/SliderWrapper';
import historyHandler from 'jd-library/historyHandler';
import SliderHeader from 'jd-library/SliderHeader';
import useInfiniteScroll from 'jd-library/useInfiniteScroll';
import NoResultFound from '../../../common/NoResultFound/NoResultFound';
import { debounce, getProductInventoryApiforSearch } from '../productrinventory.common.utils';
import ProductLists from '../product-listing/ProductLists';
import { getCurrentTabParams } from './product-search.utils';
import style from './styles/product-search.scss';

export function ProductSearchSlider(props) {
  const { token, currentTab } = props;
  const [searchText, setSearchText] = useState(() => '');
  const [isSearching, setSearching] = useState(() => false);
  const [sliderContRef, setSliderContRef] = useState(() => null);
  const [data, setData] = useState(() => null);
  const tabParams = getCurrentTabParams(currentTab);
  const { deviceData: {
    isMobile
  },
    session: { source }
  } = useSelector((state) => state);
  let isScrolled = false;
  let leftIconArr = [
    {
      className: 'icon-hdrBackNew',
      onClick: () => {
        setTimeout(() => {
          props.onHidden();
          historyHandler.closeCurrent();
        }, 300)
      }
    }
  ];

  let rightIconArr = [
    {
      className: 'icon-HDRcross',
      onClick: () => {
        setTimeout(() => {
          props.onHidden();
          historyHandler.closeAll();
        }, 300)
      }
    }
  ];

  const handleClearSearch = () => {
    setSearchText(() => '');
    setTimeout(() => {
      setData(() => null);
    }, 200);
  }

  const [isFetching, setIsFetching] = useInfiniteScroll({
    scrollContainer: sliderContRef,
    loadMoreCB: () => {
      if (data?.totalCount > data?.products?.length) {
        const params = {
          pageNo: data?.currentPage + 1,
          action: 'searchDc',
          searchStr: searchText,
          token,
          inventory: true,
          ...tabParams
        }
        getProductInventoryApiforSearch(params).then((values) => {
          setIsFetching(() => false);
          setData(() => ({ ...values, products: [...data.products, ...values.products] }));
        })
      }
      else{
        setIsFetching(() => false);
      }
    },
    useWindow: false,
    threshold: 500,
    deps: [sliderContRef]
  });

  const searchApi = useCallback(debounce((value) => {
    if (value?.length > 1) {
      setSearching(() => true);
      const params = {
        action: 'searchDc',
        searchStr: value,
        pageNo: 1,
        token,
        inventory: true,
        ...tabParams
      }
      getProductInventoryApiforSearch(params)
        .then((res) => setData(() => res))
        .then(() => setSearching(() => false));
    } else {
      setData(() => null);
    }
  }, 600), []);

  return (
    <SliderWrapper
      avoidPortal
      onHidden={handleClearSearch}
      enableHeader
      header={{
        heading:'Search',
        className: `${style['webstore-search-header']} ${isScrolled && source != 'webstore' ? 'scrolled' : ''} ${isMobile ? style['mob'] : ''}`,
        showOnlySearch: isMobile,
        searchBox: true,
        leftIcons: isMobile ? leftIconArr : [],
        searchVariant: "edit",
        rightIcons: !isMobile ? rightIconArr : [],
        autoFocus: true,
        raised: isScrolled,
        inputProps: {
          leftIconClick: leftIconArr[0].onClick,
          leftIconClass: isMobile ? 'icon-HDRback' : 'icon-HDRsearch',
          placeholder: 'Search Product',
          onChange: (e) => { setSearchText(e.target.value); searchApi(e.target.value); },
          isSearchLoading: isSearching,
          onClear: handleClearSearch,
          val: searchText
        }
      }}
    >
      <div className={style['product-search']}>
        <div className='inventory-search'>
          {data?.products?.length > 0 &&
            <>
              {data?.products?.map((l) => <ProductLists item={l} searchText={searchText} key={l.productId} loggedIn={props.loggedIn}/>)}
            </>
          }
          {
            data?.products?.length === 0 &&
            <NoResultFound />
          }
        </div>
      </div>
    </SliderWrapper >
  )
}